import './button.scss';

import { Button } from './button';

export const AddingBtn = ({ onClick }: { onClick: VoidFunction }) => {
	return (
		<Button variant="outline" style={{ width: '180px' }} onClick={onClick}>
			+ Добавить строку
		</Button>
	);
};
